<template>
  <div id="print">
    <v-overlay :value="process" absolute opacity="0.9" color="white">
      <img src="../assets/images/logo anim.svg" width="100px" height="100px" />
    </v-overlay>
    <div id="header">
      <div id="header-left">
        <img
          src="../assets/images/aawaz-logo-white.png"
          width="70px"
          height="70px"
        />
        <div id="header-info">
          <h4 id="header-name">Aawaaz Education</h4>
          <span id="header-subtitle">educate.empower.liberate</span>
        </div>
      </div>
      <div id="header-right">
        <h5>Baseline Report</h5>
      </div>
    </div>
    <div id="content">
      <div class="jumbotron" style="background-color: #f4f0ec">
        <h1 class="display-4">{{ report.studentName }}</h1>
        <p class="lead mb-n5">
          {{ report.name }} Report
          <br />
          Teacher: {{ report.teacherName }}
        </p>
      </div>
      <div id="data-container">
        <div id="canvas"></div>
        <table class="table">
          <thead>
            <tr>
              <th>Criterion</th>
              <th>Baseline</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rub in report.rubric" :key="rub">
              <th>
                {{ rub }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <b-icon-info-circle
                      color="white"
                      font-scale="1"
                      v-bind="attrs"
                      v-on="on"
                      shift-h="1"
                    ></b-icon-info-circle>
                  </template>
                  <span>
                    {{ ref[rub]["def"] }}
                  </span>
                </v-tooltip>
              </th>
              <td>{{ ref[rub][report[rub].toString()] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  data() {
    return {
      report: {},
      process: true,
      ref: {},
    };
  },
  computed: {
    ...mapState(["currentUser"]),
  },
  created: async function () {
    await fb.db
      .collection("reports")
      .doc(this.$route.params.reportId)
      .get()
      .then(async (doc) => {
        this.report = doc.data();
        await fb.db
          .doc(`rubrics/${doc.data().name}`)
          .get()
          .then((doc2) => {
            this.ref = doc2.data();
          });
        if (doc.data().student == this.currentUser.email) {
          fb.db.collection("reportReceipts").doc(doc.ref.id).delete();
        }
      });
    const trace = {};
    trace.x = this.report.rubric;
    trace.name = "Baseline";
    trace.type = "bar";
    trace.hoverinfo = "x";
    trace.marker = {
      color: "rgba(255, 145, 72, 0.5)",
      line: {
        color: "rgba(255, 145, 72, 1)",
        width: 1.5,
      },
    };
    const data = [];
    for (const rub of this.report.rubric) {
      data.push(this.report[rub]);
    }
    trace.y = data;
    const layout = {
      barmode: "group",
      xaxis: {
        tickfont: {
          size: 11,
        },
      },
      yaxis: { showticklabels: false, showgrid: false },
      plot_bgcolor: "",
      paper_bgcolor: "",
    };
    Plotly.newPlot("canvas", [trace], layout, {
      displayModeBar: false,
      responsive: true,
    });
    this.process = false;
  },
};
</script>

<style scoped>
#header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  background-color: #0d2241;
  width: 100%;
  height: 100px;
  color: white;
}
#header-left {
  display: flex;
  align-items: center;
}

#header-right {
  padding-right: 10px;
  margin-top: 10px;
}

#header-info {
  display: flex;
  flex-direction: column;
}

#header-name {
  padding-left: 20px;
}

#header-subtitle {
  padding-left: 20px;
  margin-top: -10px;
  color: #c8c8c8;
}

#content {
  padding: 30px;
}
</style>